// Chiavi i18n del namespace "sidebar" per titolo e descrizione delle card
// "Il mio spazio" e "Gestisci offerta formativa". Sono lette sia dalla sidebar
// sia dalle pagine e dal breadcrumb a cui le card puntano, cosi' i testi
// restano allineati. Se un valore cambia qui, va allineato anche in
// src/translation/{it,en}.json (sezione "sidebar" > "cards").
// Per la card utenti/gruppi vedi utilsUsersGroupsLabels.ts.
export const SIDEBAR_NAMESPACE = "sidebar";

export const SIDEBAR_MY_SPACE_TITLE_KEY = "cards.my-space.title";
export const SIDEBAR_MY_SPACE_DESCRIPTION_KEY = "cards.my-space.description";

export const SIDEBAR_TRAINING_OFFER_TITLE_KEY = "cards.training-offer.title";
export const SIDEBAR_TRAINING_OFFER_DESCRIPTION_KEY =
  "cards.training-offer.description";
